import { render, staticRenderFns } from "./livepopupCourse.vue?vue&type=template&id=741ed9db"
import script from "./livepopupCourse.vue?vue&type=script&lang=js"
export * from "./livepopupCourse.vue?vue&type=script&lang=js"
import style0 from "./livepopupCourse.vue?vue&type=style&index=0&id=741ed9db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports